import { render, staticRenderFns } from "./under-maintenance.vue?vue&type=template&id=777feb92&scoped=true&"
import script from "./under-maintenance.vue?vue&type=script&lang=js&"
export * from "./under-maintenance.vue?vue&type=script&lang=js&"
import style0 from "./under-maintenance.vue?vue&type=style&index=0&id=777feb92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777feb92",
  null
  
)

export default component.exports